import { 
    getStudents,
    createStudent,
    updateStudent,
    replaceStudent,
    deleteStudents
 } from "./js/pixabay-api";

//!=============================
